export const REPLY_TEMPLATES = [
  {
    id: "assessment-followup",
    label: "Assessment Follow-Up",
    body: "Hi {name},\n\nThank you for requesting a property assessment! I'd love to learn more about your property and walk you through exactly how we would care for it.\n\nAre you available for a quick call this week? You can also pick a time directly here: https://thebermudacohost.com/consultation",
  },
  {
    id: "pricing-overview",
    label: "Pricing Overview",
    body: "Hi {name},\n\nThank you for reaching out! Our management plans start at 15%, 25% or 50% of accommodation revenue depending on the level of service — you can see the full breakdown here: https://thebermudacohost.com/pricing\n\nEvery property receives a custom written proposal before we begin, so there are never surprises. I would be happy to prepare yours.",
  },
  {
    id: "scheduling",
    label: "Scheduling",
    body: "Hi {name},\n\nThank you! I would be happy to arrange a time. What days suit you best this week? Mornings and afternoons both work for us.\n\nOnce we confirm, I will send a short note with everything to expect.",
  },
];
